// node_modules
import axios from "axios";
// Helpers
import { AxiosHelperSingleton } from "Helpers";
// Types
import { TTerminologyDTO } from "Types";

export class TerminologyController {
    public async updateTerminologyAsync(caseId: number, terminology: TTerminologyDTO): Promise<boolean> {
        const formData = new FormData();
        formData.append("TerminologyID", `${terminology.id}`);
        formData.append("TerminologyText", `${terminology.terminology ? terminology.terminology : ""}`);
        formData.append("CaseID", `${caseId}`);
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}Terminology/Edit/${terminology.id}`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.status === 200;
    }

    public async createEmptyTerminologyAsync(caseId: number): Promise<number | undefined> {
        const formData = new FormData();
        formData.append("CaseID", `${caseId}`);
        formData.append("QueryAssistance", `${false}`);
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}Terminology/CreateEmpty`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        if (result.status === 200) {
            return result.data.terminologyID;
        } else {
            return undefined;
        }
    }

    public async deleteTerminologyAsync(terminologyId: number): Promise<boolean> {
        const formData = new FormData();
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}Terminology/Delete/${terminologyId}`,
        formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.status === 200;
    }
}

export const TerminologyControllerSingleton = new TerminologyController();